import { motion } from "framer-motion";
import { ArrowRight, MapPin, CalendarDays, Users } from "lucide-react";
import { useLang } from "@/i18n";

export default function EventBanner() {
  const { t } = useLang();
  return (
    <section id="evenement" data-testid="event-banner" className="bg-[#0A0A0C] py-28 lg:py-36 border-b border-[#27272A] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-7"
        >
          <p className="text-[#C5A059] text-xs uppercase tracking-[0.4em] mb-6">{t("event.eyebrow")}</p>
          <h2 className="font-display text-4xl md:text-6xl uppercase font-bold tracking-tight leading-[0.95]">
            International<br />Scouting Event <span className="text-[#C5A059]">2026</span>
          </h2>
          <p className="font-editorial italic text-lg md:text-xl text-[#A1A1AA] mt-8 max-w-xl">
            "{t("event.quote")}"
          </p>
          <div className="flex flex-wrap gap-x-10 gap-y-4 mt-10">
            {[
              { icon: MapPin, label: t("event.meta.location") },
              { icon: CalendarDays, label: t("event.meta.date") },
              { icon: Users, label: t("event.meta.ages") },
            ].map((item) => (
              <div key={item.label} className="flex items-center gap-3">
                <item.icon size={16} className="text-[#C5A059]" />
                <span className="text-sm text-[#A1A1AA] uppercase tracking-wider">{item.label}</span>
              </div>
            ))}
          </div>
          <p className="text-[#71717A] text-sm mt-8 max-w-lg leading-relaxed">
            {t("event.text")}
          </p>
          <div className="flex flex-wrap gap-5 mt-10">
            <a
              href="/detection"
              data-testid="event-cta-detection"
              className="group inline-flex items-center gap-3 bg-[#C5A059] text-black px-8 py-4 text-xs uppercase tracking-[0.25em] font-semibold hover:bg-[#E5C07B] transition-colors duration-300"
            >
              {t("event.cta1")}
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </a>
            <a
              href="/evenement"
              data-testid="event-cta-page"
              className="inline-flex items-center gap-3 border border-white/25 text-white px-8 py-4 text-xs uppercase tracking-[0.25em] hover:border-[#C5A059] hover:text-[#C5A059] transition-colors duration-300"
            >
              {t("event.cta2")}
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-5 relative"
        >
          <div className="absolute -inset-3 border border-[#C5A059]/40 translate-x-4 translate-y-4 pointer-events-none" />
          <img
            src="/assets/affiche-event.png"
            alt="International Scouting Event 2026 — Kinshasa"
            loading="lazy"
            className="relative w-full border border-[#27272A] grayscale-[35%] hover:grayscale-0 transition-[filter] duration-700"
            data-testid="event-poster"
          />
        </motion.div>
      </div>
    </section>
  );
}
